import { useCallback, useState } from "react";
import { RoleType } from "../Users";

const NONE_VALUE = "__NONE__";

interface UseRoleFilterResult<T extends RoleType> {
  selectedRoles: T[];
  handleRoleFilterChange: (
    filterValues: T[] | null,
    filterType: "include" | "exclude" | undefined | null
  ) => void;
}

export function useRoleFilter<T extends RoleType>(
  existingRoles: T[]
): UseRoleFilterResult<T> {
  const [selectedRoles, setSelectedRoles] = useState<T[]>([]);

  const handleRoleFilterChange = useCallback(
    (
      filterValues: T[] | null,
      filterType: "include" | "exclude" | undefined | null
    ) => {
      // When exclude/null: all checkboxes selected, include __NONE__ too
      if (
        filterType === "exclude" &&
        (filterValues === null || filterValues.length === 0)
      ) {
        setSelectedRoles([...existingRoles, NONE_VALUE as T]);
      } else if (
        (filterType === "include" || filterType === undefined) &&
        filterValues &&
        filterValues.length > 0
      ) {
        setSelectedRoles(filterValues);
      } else if (
        filterValues &&
        filterValues.length > 0 &&
        filterType === "exclude"
      ) {
        const allRoles = [...existingRoles, NONE_VALUE as T];
        const includedRoles = allRoles.filter(r => !filterValues.includes(r));
        setSelectedRoles(includedRoles as T[]);
      } else {
        setSelectedRoles([]);
      }
    },
    [existingRoles]
  );

  return { selectedRoles, handleRoleFilterChange };
}
